
<div fxLayout="row wrap" fxLayoutAlign="center">

  <!-- <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container> -->
<!-- //////Templates//// -->
  <!-- ////Adicionales//// -->
    <mat-tab-group style="width: 100%; background: white;">
      <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.QUESTIONS' | translate}}">

        <preguntasAdicionales
        [productoCertificar]="productoFocus"
        [idiomas]="idiomas"
        [preguntasAdicionales]="preguntasAdicionalesFocus"
        [cargando]="cargando"
        [pasoCompleto]="pasoCompleto"
        [bloqueaSeccionAdicional]="bloqueaSeccionAdicional"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        (statusSinAdicionales)="actualizaStatusSinAdicionales($event)"
        (sinAdicionalesFocus)="sinAdicionalesFocus($event)"
        ></preguntasAdicionales>

        <!--------------------------->
      </mat-tab>

      <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.TRANSLATE' | translate}}" *ngIf="OcultarTraducionSinAdicio"  >

        <traducciones
        [productoCertificar]="productoFocus"
        [idiomas]="idiomas"
        [preguntasAdicionales]="preguntasAdicionalesFocus"
        [preguntasTraduccionesAdicionalesFocus]="preguntasTraduccionesAdicionalesFocus"
        [actualizaAdicionales] = "eventsSubject.asObservable()"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        ></traducciones>

      </mat-tab>

      <mat-tab label="{{'CERTIFICAR.ADICIONALES.TABS.PREVIEW' | translate}}">

        <previsualizacion
        [idiomas]="idiomas"
        [preguntasTraduccionesAdicionalesFocus]="preguntasTraduccionesAdicionalesFocus"
        [preguntasAdicionalesFocus]="preguntasAdicionalesFocus"
        [actualizaAdicionales] = "eventsSubject.asObservable()"
        ></previsualizacion>
      </mat-tab>

    </mat-tab-group>

  <ng-container *ngIf="validacionEncuestaPrincipal">
  <ng-container *ngIf="banderaEncuestaFocus">
  <div fxLayout="row" fxLayoutAlign="start start" class="mb-20 EvaluarBt ">

    <div *ngIf="banderaEncuestaFocus.estatusVerificacion==1 || banderaEncuestaFocus.estatusVerificacion==5" class="p-16" fxLayoutAlign="center center">
        <div class="h1"> <button mat-raised-button color="accent" (click)="actualizaBanderaEvaluarEncuesta()">Enviar encuesta a aprobacion </button></div>
    </div>
    <!------- boton  --------->
    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
        <div *ngIf="banderaEncuestaFocus.estatusVerificacion==2" class="p-16" fxLayoutAlign="center center">
            <div class="h3"><code>{{'CERTIFICAR.ADICIONALES.FOCUS.ENVIO-AUTORIZACION' | translate}}</code></div>
        </div>
    </div>
    <div class="footer" fxLayout="row" fxLayoutAlign="center center">
        <div *ngIf="banderaEncuestaFocus.estatusVerificacion==3" class="p-16" fxLayoutAlign="center center">
            <div class="h3"><code>{{'CERTIFICAR.ADICIONALES.FOCUS.AUTORIZACION-OK' | translate}}</code></div>
        </div>
    </div>

    </div>
  </ng-container>
  </ng-container>

  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">

    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20">
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto"  mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearAdicionales()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.REACTIVOS.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearAdicionales()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.REACTIVOS.STATUS.UNLOCK' | translate}}
      <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
    </button>
  </div>

</div>
